export default "__VITE_ASSET__LWCcNXmk__"